module.exports = __webpack_public_path__ + "Flag-535.3425dd20d5920be43fc5ea7b3cff08eb.svg";